/***
 *
 *   TICKET ATTACHMENTS
 *   Rail card: images as a thumbnail grid, then files as rows. Lives beside
 *   the conversation instead of above it, so attachments no longer take
 *   height from the description and the feed.
 *
 **********/

import React from 'react';
import Style from './owner.tailwind';
import TicketAttachment from './media';
import TicketFile from './file';
import { Icon } from 'components/lib';
import { useTranslate } from 'app/translations';

export const splitAttachments = (attachments) =>
    (attachments || []).reduce(
        (acc, media) => {
            if (media.image_id) acc.withImage.push(media);
            else acc.withFile.push(media);
            return acc;
        },
        { withImage: [], withFile: [] },
    );

const TicketAttachments = ({ medias }) => {
    const { _t } = useTranslate();
    const count = medias.withImage.length + medias.withFile.length;

    if (!count) return null;

    return (
        <section className={Style.container}>
            <header className={`${Style.header} flex items-center gap-2`}>
                <h3 className={Style.title}>{_t('ticket.detail.attachments')}</h3>
                <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-muted px-1.5 py-0.5 text-[10px] font-semibold text-text-muted">
                    <Icon image="paperclip" size={11} color="currentColor" />
                    {count}
                </span>
            </header>

            <div className={`${Style.body} space-y-3`}>
                <TicketAttachment medias={medias.withImage} grid hideTitle />
                {medias.withFile.length > 0 && <TicketFile medias={medias.withFile} hideTitle />}
            </div>
        </section>
    );
};

export default TicketAttachments;
